import qs from 'qs'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useWalletConnection } from 'hooks/useWalletConnection'
import { useUser } from 'hooks/user/useUser'

export const useReferralCode = () => {
  const location = useLocation()
  const { isConnected } = useUser('wallet')
  const { connectWallet } = useWalletConnection()
  const { referralcode } = qs.parse(location.search, { ignoreQueryPrefix: true })
  useEffect(() => {
    if (!referralcode) return
    if (!isConnected) connectWallet('signUp', referralcode)
  }, [isConnected])
}
